import { render, staticRenderFns } from "./PackList.vue?vue&type=template&id=c585d44a&scoped=true"
import script from "./PackList.vue?vue&type=script&lang=js"
export * from "./PackList.vue?vue&type=script&lang=js"
import style0 from "./PackList.vue?vue&type=style&index=0&id=c585d44a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c585d44a",
  null
  
)

export default component.exports